import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GeneralError } from '../../domain/errors/general'
import { Envs } from '../../envs'

export class DeleteResource {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(externalResourceId: string): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.DELETE,
      url: `${Envs.BFF_PRODUCT_URL}/resources/${externalResourceId}`,
    })

    if (response.statusCode === HttpStatusCode.NO_CONTENT) {
      return
    }

    throw new GeneralError()
  }
}
